export default function () {
	const EANs = Array.from(document.querySelectorAll('*'))
		.reduce((acc, element) => {
			const [match] = element.textContent?.match(/(\d{13})/) || [undefined];

			if (match) acc[match] = match;

			return acc;
		}, {} as Record<string, string>);

	return Object.keys(EANs)
}